type Service = {
  readonly baseUrl: string;
  readonly paths: Record<string, string>;
};

export type AppConfig = {
  readonly services: {
    readonly account: Service;
    readonly user: Service;
    readonly order: Service;
    readonly finance: Service;
    readonly product: Service;
    readonly shopping: Service;
    readonly customerNetSpringBoot: Service;
    readonly customerNetCustomer: Service;
    readonly customerNetProduct: Service;
    readonly customerNetUser: Service;
    readonly customerNetOrder: Service;
    readonly customerNetPartsSpringBoot: Service;
  };
  readonly integrations: {
    readonly captcha: {
      readonly siteKey: string;
    };
    readonly botIframeUrl: string;
    readonly legacyB2BNewUserUrl: string;
    readonly legacyB2BForgotPasswordUrl: string;
    readonly legacyB2BForgotUsernameUrl: string;
    readonly customernetUrl: string;
    readonly legacyLoginUrl: string;
    readonly legacyLogoutUrl: string;
    readonly oktaLoginUrl: string;
    readonly cyberSource: {
      requestToUrl: string;
      responseToUrl: string;
      accessKey: string;
      profileId: string;
    };
  };
  readonly constants: Record<string, unknown>;
  readonly assets: {
    readonly geMigratedRootImagesUrl: string;
    readonly geMigratedAssets: string;
  };
};

const BASE_CONFIG = {
  services: {
    account: {
      paths: {
        accounts: '/account',
      },
    },
    user: {
      paths: {
        accounts: '/userAccount',
      },
    },
    order: {
      paths: {
        orders: '/order',
      },
    },
    finance: {
      paths: {
        finance: '/finance',
      },
    },
    product: {
      paths: {
        products: '/product',
      },
    },
    shopping: {
      paths: {
        shopping: '/shopping',
      },
    },
    customerNetSpringBoot: {
      paths: {
        accounts: '/account',
        orderability: '/order/itemOrderability',
        availability: '/availability',
        pricing: '/pricing',
        shipping: '/order/shipping',
        orders: '/order',
        pod: '/order/pod',
        deliveryPicture: '/order/deliveryPicture',
        invoice: '/invoice',
        statement: '/statement',
      },
    },
    customerNetCustomer: {
      paths: {
        siteManagement: '/siteManagement',
        users: '/user',
      },
    },
    customerNetProduct: {
      paths: {
        items: '/item',
        filters: '/filter',
        pim: '/pim',
      },
    },
    customerNetUser: {
      paths: {
        users: '/user',
        account: '/account',
      },
    },
    customerNetOrder: {
      paths: {
        deliveryCalendar: '/delivery-calendar',
        orders: '/order',
        paymentSignature: '/signature',
        tax: '/tax',
      },
    },
    customerNetPartsSpringBoot: {
      paths: {
        orders: '/order',
        orderList: '/order/details',
        priceSubTypes: '/validatePriceSubType',
        pricing: '/pricing',
        tax: '/tax',
      },
    },
  },
  integrations: {
    captcha: {
      script: 'https://www.google.com/recaptcha/api.js',
      siteKey: '6LfQ5C8sAAAAAMW8CjE6wB3pIuAabMlwDgih69YR',
    },
    botIframeUrl: '',
    legacyB2BNewUserUrl:
      'https://b2b.geappliances.com/pwm/public/newuser?forwardURL=',
    legacyB2BForgotPasswordUrl:
      'https://b2b.geappliances.com/pwm/public/forgottenpassword?forwardURL=',
    legacyB2BForgotUsernameUrl:
      'https://b2b.geappliances.com/pwm/public/forgottenusername?forwardURL=',
  },
  constants: {},
  security: {
    userDetailsDecryptionKey: 'R0VhcHBsaWVhbmNlIzEyMw==',
  },
  assets: {
    geMigratedRootImagesUrl:
      'https://www.geappliances.com/content/migrated-root-images',
    geMigratedAssets: 'https://www.geappliances.com/content/migrated-assets',
  },
  storageKeys: {
    local: {
      userDetails: 'gea_b2bp_user',
      activeCheckoutData: 'active_checkout_data',
    },
    session: {},
    cookies: {},
  },
} as const;

export default BASE_CONFIG;
